import { PUBLIC_ENDPOINTS } from '@/constants/api'
import { postData } from '@/services/api'

/**
 * 📌 Website API Service
 */
export const WebsiteService = {
  submitHelp: (data: object) => postData(PUBLIC_ENDPOINTS.website.help, data),
  submitForgotPassword: (data: object) => postData(PUBLIC_ENDPOINTS.website.forgotPassword, data),
}
